var isEnabled = false;

$(document).on('mousemove', function(e) {
  movecursor(e);
});

function movecursor(event) {
  var xPos = event.clientX;
  var yPos = event.clientY;
  var xOffset = -19; /* -30 */
  var yOffset = -22;/* -35 */
  $('#c-cursor').css({
    'top': yPos + yOffset,
    'left': xPos + xOffset,
  });
  if (!isEnabled){
    document.body.classList.add("nocursor");
    document.getElementById("c-cursor").classList.add("c-enabled");
    isEnabled = true;
  }

}

addEventListener("mousedown", (event) => {
  if (window.innerWidth < 990) {
    return;
  }
    var el =  document.getElementById("c-cursor");
    el.classList.remove("c-cursor-click");
    void el.offsetWidth;
    el.classList.add("c-cursor-click");

    document.getElementById("tap-audio").currentTime = 0;
    document.getElementById("tap-audio").play();
    

   })